import axios from 'axios';
import {
  createIsomorphicFn,
} from '@tanstack/react-start'

const baseUrl = createIsomorphicFn().
  server(() => process.env.BASE_URL || 'http://localhost:4200').
  client(() => "")

const getServerHeaders = createIsomorphicFn()
  .server(() => {
    try {
      const GLOBAL_EVENT_STORAGE_KEY = Symbol.for("tanstack-start:event-storage");
      const eventStorage = globalThis[GLOBAL_EVENT_STORAGE_KEY];
      if (eventStorage) {
        const store = eventStorage.getStore();
        if (store && store.h3Event && store.h3Event.req) {
          const req = store.h3Event.req;
          const headers = req.headers;
          if (headers) {
            const host = typeof headers.get === 'function' ? headers.get('host') : headers['host'];
            const xForwardedHost = typeof headers.get === 'function' ? headers.get('x-forwarded-host') : headers['x-forwarded-host'];
            const referer = typeof headers.get === 'function' ? headers.get('referer') : headers['referer'];
            
            const forwardedHeaders = {};
            if (host) forwardedHeaders['host'] = host;
            if (xForwardedHost) forwardedHeaders['x-forwarded-host'] = xForwardedHost;
            if (referer) forwardedHeaders['referer'] = referer;
            return forwardedHeaders;
          }
        }
      }
    } catch (e) {
      console.error('Failed to extract server headers:', e);
    }
    return {};
  })
  .client(() => ({}));

const api = (method, url, variables, config = {}) => {
  const isFormData = variables instanceof FormData;
  const extraHeaders = getServerHeaders() || {};

  return axios({
    method,
    url: `${baseUrl()}/api/v1/${url}`,
    params: method !== 'post' ? variables : undefined,
    data: method === 'post' ? variables : undefined,
    signal: config.signal,
    paramsSerializer: (params) => {
      const searchParams = new URLSearchParams();
      for (const key in params) {
        const val = params[key];
        if (val === null || val === undefined || val === '') continue;
        if (Array.isArray(val)) {
          val.forEach((v) => searchParams.append(`${key}[]`, v));
        } else {
          searchParams.append(key, val);
        }
      }
      return searchParams.toString();
    },
    headers: {
      'Content-Type': isFormData ? 'multipart/form-data' : 'application/json',
      ...extraHeaders,
      ...config.headers,
    },
  });
};

export default api;